import { Navigate } from "react-router-dom";

export default function RedirectToNotebook() {
  return <Navigate to="/discipline-manager" replace />;
}
